/* ==========================================================================
   Kingbolen Diagnostic Homepage — shared behavior
   Re-runs on both first paint and Shopify theme-editor section reloads.
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal (fade + rise) ---------- */
  function initReveal(root) {
    root = root || document;

    // Stagger delays for items inside a [data-kb-stagger] group
    root.querySelectorAll('[data-kb-stagger]').forEach(function (group) {
      var items = group.querySelectorAll(':scope > .kb-reveal');
      items.forEach(function (item, i) {
        item.style.transitionDelay = i * 80 + 'ms';
      });
    });

    var targets = root.querySelectorAll('.kb-reveal:not(.is-in)');
    if (reduceMotion) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Stats count-up (per section instance) ---------- */
  function formatNumber(n) {
    return Math.round(n).toLocaleString('en-US');
  }
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    var suffix = el.getAttribute('data-suffix') || '';
    if (reduceMotion || isNaN(target)) {
      el.textContent = (isNaN(target) ? el.textContent : formatNumber(target) + suffix);
      return;
    }
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatNumber(target * eased) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatNumber(target) + suffix;
        el.classList.add('kb-pulse');
      }
    }
    requestAnimationFrame(step);
  }
  function initStats(root) {
    root = root || document;
    root.querySelectorAll('[data-kb-stats-row]').forEach(function (row) {
      if (row.dataset.kbStatsInit) return;
      var items = row.querySelectorAll('.kb-stat-item');
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          item.classList.add('is-in');
          animateCount(item.querySelector('.kb-num'));
        });
        row.dataset.kbStatsInit = '1';
        return;
      }
      var triggered = false;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !triggered) {
            triggered = true;
            items.forEach(function (item, i) {
              item.classList.add('is-in');
              var num = item.querySelector('.kb-num');
              setTimeout(function () { animateCount(num); }, i * 100 + 150);
            });
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });
      observer.observe(row);
      row.dataset.kbStatsInit = '1';
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(root) {
    root = root || document;
    root.querySelectorAll('.kb-faq-q').forEach(function (btn) {
      if (btn.dataset.kbBound) return;
      btn.dataset.kbBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.kb-faq-item');
        var isOpen = item.classList.contains('kb-open');
        item.classList.toggle('kb-open');
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ---------- Creator / carousel nav buttons ---------- */
  function initCarousels(root) {
    root = root || document;
    root.querySelectorAll('[data-kb-carousel]').forEach(function (scroller) {
      var wrap = scroller.closest('[data-kb-carousel-wrap]') || scroller.parentElement;
      var prevBtn = wrap.querySelector('[data-kb-prev]');
      var nextBtn = wrap.querySelector('[data-kb-next]');
      if (prevBtn && !prevBtn.dataset.kbBound) {
        prevBtn.dataset.kbBound = '1';
        prevBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: -300, behavior: 'smooth' });
        });
      }
      if (nextBtn && !nextBtn.dataset.kbBound) {
        nextBtn.dataset.kbBound = '1';
        nextBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: 300, behavior: 'smooth' });
        });
      }
    });
  }

  /* ---------- Header motion: scroll shadow + cart count bump ----------
     Targets the real Warehouse header — .shopify-section__header comes
     from the section's schema "class", so it exists automatically with
     zero Liquid changes. Safe no-op if the header markup ever changes. */
  function initHeaderMotion(root) {
    root = root || document;

    var header = root.querySelector ? root.querySelector('.shopify-section__header') : null;
    if (!header && root.matches && root.matches('.shopify-section__header')) header = root;
    if (header && !header.dataset.kbScrollBound) {
      header.dataset.kbScrollBound = '1';
      var onScroll = function () {
        if (window.scrollY > 8) header.classList.add('kb-header-scrolled');
        else header.classList.remove('kb-header-scrolled');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var cartCount = document.querySelector('.header__cart-count');
    if (cartCount && !cartCount.dataset.kbBound) {
      cartCount.dataset.kbBound = '1';
      var lastValue = cartCount.textContent;
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function () {
          if (cartCount.textContent !== lastValue) {
            lastValue = cartCount.textContent;
            cartCount.classList.remove('kb-bump');
            void cartCount.offsetWidth; // restart animation
            cartCount.classList.add('kb-bump');
          }
        });
        observer.observe(cartCount, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  /* ---------- Creator video cards: in-site playback + oEmbed auto-fetch ---------- */
  function extractYouTubeId(url) {
    if (!url) return null;
    var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  }

  function playInline(thumb, videoId, titleText) {
    thumb.innerHTML =
      '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" ' +
      'title="' + (titleText ? titleText.replace(/"/g, '&quot;') : 'Video') + '" ' +
      'frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
      'allowfullscreen loading="lazy"></iframe>';
    thumb.classList.add('kb-video-playing');
    thumb.removeAttribute('role');
    thumb.removeAttribute('tabindex');
  }

  function initCreatorVideos(root) {
    root = root || document;
    root.querySelectorAll('.kb-creator-card').forEach(function (card) {
      if (card.dataset.kbVideoBound) return;
      card.dataset.kbVideoBound = '1';

      var thumb = card.querySelector('[data-kb-video-trigger]');
      if (!thumb) return;
      var videoUrl = thumb.getAttribute('data-video-url');
      if (!videoUrl) return;

      var titleEl = card.querySelector('[data-kb-auto-title]');
      var nameEl = card.querySelector('[data-kb-auto-name]');
      var avatarEl = card.querySelector('[data-kb-auto-avatar]');

      // Auto-fill thumbnail from YouTube's default image when no manual image was uploaded
      if (thumb.hasAttribute('data-kb-auto-thumb')) {
        var autoId = extractYouTubeId(videoUrl);
        if (autoId) {
          var img = document.createElement('img');
          img.className = 'kb-thumb-img';
          img.loading = 'lazy';
          img.alt = titleEl ? titleEl.textContent : '';
          img.src = 'https://img.youtube.com/vi/' + autoId + '/hqdefault.jpg';
          thumb.insertBefore(img, thumb.firstChild);
        }
      }

      // Auto-fetch title/channel name via YouTube oEmbed when left blank in the section settings
      if ((titleEl || nameEl || avatarEl) && 'fetch' in window) {
        var endpoint = 'https://www.youtube.com/oembed?url=' + encodeURIComponent(videoUrl) + '&format=json';
        fetch(endpoint)
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data) return;
            if (titleEl && data.title) titleEl.textContent = data.title;
            if (nameEl && data.author_name) nameEl.textContent = data.author_name;
            if (avatarEl && data.author_name) avatarEl.textContent = data.author_name.substring(0, 2).toUpperCase();
          })
          .catch(function () { /* silent — manual fallback text (if any) stays as-is */ });
      }

      thumb.addEventListener('click', function (e) {
        var id = extractYouTubeId(videoUrl);
        if (!id) return; // no valid YouTube ID found — let the native link behavior happen (opens YouTube)
        e.preventDefault();
        var titleText = titleEl ? titleEl.textContent : '';
        playInline(thumb, id, titleText);
      });
    });
  }

  /* ---------- Vehicle Finder: compare checkbox counter (UI-only, no compare page yet) ---------- */
  function initCompareCheckboxes(root) {
    root = root || document;
    var bar = document.querySelector('[data-kb-compare-bar]');
    var countEl = bar ? bar.querySelector('[data-kb-compare-count]') : null;
    var clearBtn = bar ? bar.querySelector('[data-kb-compare-clear]') : null;

    function updateBar() {
      if (!bar || !countEl) return;
      var checked = document.querySelectorAll('[data-kb-compare]:checked');
      if (checked.length > 0) {
        countEl.textContent = checked.length;
        bar.hidden = false;
      } else {
        bar.hidden = true;
      }
    }

    root.querySelectorAll('[data-kb-compare]').forEach(function (box) {
      if (box.dataset.kbBound) return;
      box.dataset.kbBound = '1';
      box.addEventListener('change', updateBar);
    });

    if (clearBtn && !clearBtn.dataset.kbBound) {
      clearBtn.dataset.kbBound = '1';
      clearBtn.addEventListener('click', function () {
        document.querySelectorAll('[data-kb-compare]:checked').forEach(function (box) { box.checked = false; });
        updateBar();
      });
    }

    updateBar();
  }

  /* ---------- Collection tabs (Creader Elite style) ---------- */
  function initCollectionTabs(root) {
    root = root || document;
    root.querySelectorAll('[data-kb-tabs]').forEach(function (tabBar) {
      if (tabBar.dataset.kbBound) return;
      tabBar.dataset.kbBound = '1';
      var buttons = tabBar.querySelectorAll('.kb-tab');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var targetId = btn.getAttribute('data-kb-tab-target');
          var target = document.getElementById(targetId);
          if (!target) return;

          buttons.forEach(function (b) {
            b.classList.remove('kb-tab-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('kb-tab-active');
          btn.setAttribute('aria-selected', 'true');

          var panelGroup = target.parentElement.querySelectorAll('.kb-tab-panel');
          panelGroup.forEach(function (p) { p.classList.remove('kb-tab-panel-active'); });
          target.classList.add('kb-tab-panel-active');

          // Re-run reveal/stagger for the newly shown panel's product grid
          initReveal(target);
        });
      });
    });
  }

  /* ---------- Optional: header scroll shadow ----------
     Add class "kb-header-shadow" to your theme's <header> element
     to enable this. Safe no-op if no such element exists. */
  function initHeaderShadow() {
    var header = document.querySelector('.kb-header-shadow');
    if (!header || header.dataset.kbBound) return;
    header.dataset.kbBound = '1';
    function onScroll() {
      if (window.scrollY > 8) header.classList.add('kb-scrolled');
      else header.classList.remove('kb-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(root) {
    initReveal(root);
    initStats(root);
    initFaq(root);
    initCarousels(root);
    initHeaderShadow();
    initHeaderMotion(root);
    initCollectionTabs(root);
    initCreatorVideos(root);
    initCompareCheckboxes(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  // Re-run when a merchant edits/reorders a section in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:reorder', function () { initAll(document); });
})();
